import React, { useEffect, useState } from 'react';
import { getUsuarios, crearUsuario, editarUsuario, resetPasswordUsuario, getPerfiles } from '../services/api';
import { useAuth } from '../context/AuthContext';
import UsuariosTabs from '../components/UsuariosTabs';

const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const VACIO = { nombre: '', email: '', password: '', perfil_id: '' };

export default function Usuarios() {
  const { user } = useAuth();
  const [lista, setLista] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [modal, setModal] = useState(null);   // { editId?, form }
  const [pwd, setPwd] = useState(null);        // { id, nombre, value }
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    getUsuarios().then(r => setLista(r.data)).catch(() => {});
    getPerfiles().then(r => setPerfiles(r.data.perfiles)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 4000); };

  const abrirNuevo = () => setModal({ form: { ...VACIO, perfil_id: perfiles[0]?.id || '' } });
  const abrirEditar = (u) => setModal({ editId: u.id, form: { nombre: u.nombre, email: u.email, password: '', perfil_id: u.perfil_id || '' } });

  const guardar = async () => {
    const f = modal.form;
    if (!f.nombre.trim() || !f.perfil_id) return flash(false, 'Nombre y perfil son requeridos');
    setBusy(true);
    try {
      if (modal.editId) {
        await editarUsuario(modal.editId, { nombre: f.nombre, perfil_id: f.perfil_id });
      } else {
        if (!f.email.trim() || !f.password) { setBusy(false); return flash(false, 'Email y contraseña son requeridos'); }
        await crearUsuario({ nombre: f.nombre, email: f.email, password: f.password, perfil_id: f.perfil_id });
      }
      setModal(null); load(); flash(true, '✅ Guardado');
    } catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };

  const toggleActivo = async (u) => {
    try { await editarUsuario(u.id, { activo: !u.activo }); load(); }
    catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo cambiar')); }
  };

  const guardarPwd = async () => {
    if (!pwd.value || pwd.value.length < 6) return flash(false, 'La contraseña debe tener al menos 6 caracteres');
    setBusy(true);
    try { await resetPasswordUsuario(pwd.id, pwd.value); setPwd(null); flash(true, '✅ Contraseña actualizada'); }
    catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo')); }
    finally { setBusy(false); }
  };

  return (
    <div style={s.wrap}>
      <UsuariosTabs />
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Usuarios</h1>
          <p style={s.sub}>Cuentas de acceso de la empresa. El acceso a cada módulo depende del perfil.</p>
        </div>
        <button style={s.btn} onClick={abrirNuevo}>+ Nuevo usuario</button>
      </div>

      {msg && <div style={{ ...s.msg, background: msg.ok ? '#064e3b' : '#450a0a', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.text}</div>}

      <div style={s.card}>
        <table style={s.table}>
          <thead><tr>{['Nombre', 'Email', 'Perfil', 'Estado', 'Creado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin usuarios.</td></tr>}
            {lista.map(u => (
              <tr key={u.id}>
                <td style={{ ...s.td, fontWeight: 600, color: '#e2e8f0' }}>{u.nombre}{u.id === user?.id && <span style={s.you}> (tú)</span>}</td>
                <td style={{ ...s.td, color: '#93c5fd' }}>{u.email}</td>
                <td style={s.td}>{u.perfil_nombre || '—'}</td>
                <td style={s.td}><span style={{ ...s.badge, background: u.activo ? '#10b98122' : '#64748b22', color: u.activo ? '#10b981' : '#94a3b8' }}>{u.activo ? 'Activo' : 'Inactivo'}</span></td>
                <td style={{ ...s.td, color: '#64748b', fontSize: 12 }}>{fdate(u.created_at)}</td>
                <td style={s.td}>
                  <button style={s.link} onClick={() => abrirEditar(u)}>Editar</button>
                  <button style={s.link} onClick={() => setPwd({ id: u.id, nombre: u.nombre, value: '' })}>Contraseña</button>
                  {u.id !== user?.id && <button style={{ ...s.link, color: u.activo ? '#fca5a5' : '#6ee7b7' }} onClick={() => toggleActivo(u)}>{u.activo ? 'Desactivar' : 'Activar'}</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={modal.editId ? 'Editar usuario' : 'Nuevo usuario'} onClose={() => setModal(null)}>
          <Field label="Nombre">
            <input style={s.input} value={modal.form.nombre} onChange={e => setModal({ ...modal, form: { ...modal.form, nombre: e.target.value } })} />
          </Field>
          <Field label="Email">
            <input style={{ ...s.input, ...(modal.editId ? s.inputRO : {}) }} value={modal.form.email} disabled={!!modal.editId}
              onChange={e => setModal({ ...modal, form: { ...modal.form, email: e.target.value } })} />
          </Field>
          {!modal.editId && (
            <Field label="Contraseña (mín. 6)">
              <input style={s.input} type="password" value={modal.form.password} onChange={e => setModal({ ...modal, form: { ...modal.form, password: e.target.value } })} />
            </Field>
          )}
          <Field label="Perfil">
            <select style={s.input} value={modal.form.perfil_id} onChange={e => setModal({ ...modal, form: { ...modal.form, perfil_id: e.target.value } })}>
              <option value="">— Seleccionar —</option>
              {perfiles.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </Field>
          <div style={s.modalBtns}>
            <button style={s.btnGhost} onClick={() => setModal(null)}>Cancelar</button>
            <button style={s.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button>
          </div>
        </Modal>
      )}

      {pwd && (
        <Modal title={`Contraseña de ${pwd.nombre}`} onClose={() => setPwd(null)}>
          <Field label="Nueva contraseña (mín. 6)">
            <input style={s.input} type="password" value={pwd.value} onChange={e => setPwd({ ...pwd, value: e.target.value })} />
          </Field>
          <div style={s.modalBtns}>
            <button style={s.btnGhost} onClick={() => setPwd(null)}>Cancelar</button>
            <button style={s.btn} disabled={busy} onClick={guardarPwd}>{busy ? 'Guardando…' : 'Cambiar'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={s.label}>{label}</label>
    {children}
  </div>
);

const Modal = ({ title, onClose, children }) => (
  <div style={s.overlay} onClick={onClose}>
    <div style={s.modal} onClick={e => e.stopPropagation()}>
      <h3 style={s.modalTitle}>{title}</h3>
      {children}
    </div>
  </div>
);

const s = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  badge: { padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
  you: { color: '#3b82f6', fontSize: 11, fontWeight: 500 },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, marginRight: 12, padding: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, width: 420, maxWidth: '92vw' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: '0 0 16px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
  label: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  input: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '9px 12px', color: '#f1f5f9', fontSize: 14 },
  inputRO: { opacity: .6, cursor: 'not-allowed' },
};
